import { render, staticRenderFns } from "./AllLeaves.vue?vue&type=template&id=3d79b2ec"
import script from "./AllLeaves.vue?vue&type=script&lang=js"
export * from "./AllLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports